var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_vm._t("default",null,{keyId:_vm.modalOpensCounter,keyUpdater:_vm.onModalShow})],2)}
var staticRenderFns = []

export { render, staticRenderFns }